import { ButtonSelection, DragEvent as D3DragEvent } from "app/core/components/dashboard/d3/types"
import { SvgEventHandlers } from "./types"
import * as d3 from "d3"
import * as params from "app/core/components/dashboard/d3/params"
import * as svg from "app/core/components/dashboard/d3/svg"
import { Selection } from "d3-selection"
import { getSelection } from "app/core/components/dashboard/d3/select"

export const register = (event: D3DragEvent, handlers?: SvgEventHandlers) => {
  const initialCoordinates = new DOMPoint(event.x, event.y)
  const multiselectRect = d3
    .select("#svg-dashboard")
    .append("rect")
    .classed("multiselect-rect", true)
    .attr("x", initialCoordinates.x)
    .attr("y", initialCoordinates.y)
    .attr("width", 0)
    .attr("height", 0)
    .style("stroke-width", 1)
    .style("stroke", "lightgrey")
    .style("fill", "#f0f0f080") as Selection<SVGRectElement, any, HTMLElement, any>

  const dragRect = multiselectRect.node() as SVGRectElement
  if (!dragRect) {
    return
  }
  event
    .on("drag", function (event: D3DragEvent) {
      const minX = Math.max(0, initialCoordinates.x + Math.min(0, event.x - initialCoordinates.x))
      const minY = Math.max(0, initialCoordinates.y + Math.min(0, event.y - initialCoordinates.y))
      const maxX = Math.min(
        params.width,
        initialCoordinates.x + Math.max(0, event.x - initialCoordinates.x),
      )
      const maxY = Math.min(
        params.height,
        initialCoordinates.y + Math.max(0, event.y - initialCoordinates.y),
      )

      const dragRect = new DOMRect(minX, minY, maxX - minX, maxY - minY)
      multiselectRect
        .attr("x", dragRect.x)
        .attr("y", dragRect.y)
        .attr("width", dragRect.width)
        .attr("height", dragRect.height)

      svg.buttons().each(function (buttonDatum) {
        const button = d3.select(this) as unknown as ButtonSelection
        const buttonNode = button.node()
        if (buttonNode) {
          const buttonRect = new DOMRect(
            buttonDatum.x,
            buttonDatum.y,
            buttonDatum.width,
            buttonDatum.height,
          )
          const buttonIsInRect = rectsIntersect(dragRect, buttonRect)
          button.classed("soft-selected", buttonIsInRect)
        }
      })
    })
    .on("end", function (event: D3DragEvent) {
      svg.buttons().each(function () {
        const button = d3.select(this) as unknown as ButtonSelection
        const isSelected = buttonIsSelected(
          button,
          button.classed("soft-selected"),
          event.sourceEvent,
        )
        button.classed("selected", isSelected).classed("soft-selected", false)
      })
      handlers?.select?.(getSelection(), event.sourceEvent)
      multiselectRect.remove()
    })
}

const rectsIntersect = (rect1: DOMRect, rect2: DOMRect): boolean => {
  return (
    rect1.right >= rect2.left &&
    rect2.right >= rect1.left &&
    rect1.bottom >= rect2.top &&
    rect2.bottom >= rect1.top
  )
}

const buttonIsSelected = (button: ButtonSelection, softSelected: boolean, event: DragEvent) => {
  if (event.shiftKey) {
    return softSelected || button.classed("selected")
  }
  if (event.metaKey) {
    return softSelected !== button.classed("selected")
  }
  return softSelected
}
